import { defaultConfig } from '../types';
const fillProtocol = (url) => {
    if (/^\/\//.test(url)) {
        return 'https:' + url;
    }
    return url;
};
// 改方法待验证
const isCdnUrl = (source) => {
    if (typeof (source === null || source === void 0 ? void 0 : source.uri) === 'string' &&
        /^(http(s?):)?\/\//.test(source === null || source === void 0 ? void 0 : source.uri)) {
        return true;
    }
    return false;
};
import process from './process';
import { getCdnAvailUrl } from './getCdnAvailUrl';
const updateDefaultConfig = (patchConfig) => Object.assign(defaultConfig, patchConfig);
export { fillProtocol, isCdnUrl, process, updateDefaultConfig, getCdnAvailUrl };
